import { getBaseMetaTitle } from '@/environments'

const winnerArchiveDetail = () => import('./Main')

const route = {
  path: '/archive/winner/:year/:categoryName/:name',
  name: 'winnerArchiveDetail',
  meta: {
    title: `Archive - ${getBaseMetaTitle}`
  },
  component: winnerArchiveDetail
}

export default route
